import React from 'react';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import CircularProgress from '@material-ui/core/CircularProgress';

import Carousel from 'react-material-ui-carousel';

import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
    headerGrid: {
        paddingTop: '2rem',
        paddingLeft: '1rem',
        textAlign: 'center'
    },
    contentGrid: {
        padding: '1rem'
    },
    paper: {
        padding: theme.spacing(0.5),
        margin: `${theme.spacing(1)}px auto`,
        border: '5px solid #000',
        maxWidth: '1005px',
        height: '413px',
    },
    paperCarousel: {
        maxWidth: '1000px',
        height: '395px'
    },
    image: {
        width: '100%',
        height: '100%'
    }
})

class CarouselComponent extends React.Component {
    render() {
        const { classes } = this.props
        return (
            <Grid container direction="row">
                <Grid item xs={12} className={classes.headerGrid}>
                    <Typography variant="h4">
                        Gallery
                    </Typography>
                </Grid>
                <Grid item xs={12} sm={12} className={classes.contentGrid}>
                    <Paper variant="outlined"
                        square={true} className={classes.paper}>
                        {this.props.items.length ?
                            <Carousel>
                                {this.props.items.map(x => (
                                    <Paper className={classes.paperCarousel}
                                        key={x.name}>
                                        <img src={x.url} className={classes.image} alt="img" />
                                    </Paper>
                                ))}

                            </Carousel>
                            :
                            <Grid container alignItems="center" justify="center">
                                <CircularProgress />
                            </Grid>
                        }
                    </Paper>
                </Grid>
            </Grid>
        )
    }
}

export default withStyles(styles, { withTheme: true })(CarouselComponent);